<template>
  <register></register>
</template>

<script>
  import Register from './components/register'
  export default {
    components: {
      Register
    }
  }
</script>

<style scoped>

</style>
